import { render, staticRenderFns } from "./EmailTemplateField.vue?vue&type=template&id=8d2fc1c2&"
import script from "./EmailTemplateField.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateField.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateField.vue?vue&type=style&index=0&id=8d2fc1c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports